import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-600 rounded-full mix-blend-screen filter blur-3xl opacity-10 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-600 rounded-full mix-blend-screen filter blur-3xl opacity-10 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-purple-500 rounded-full mix-blend-screen filter blur-3xl opacity-10 animate-blob animation-delay-4000"></div>
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 lg:space-y-8 animate-fade-in-up pr-2 lg:pr-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-normal break-words pb-2">
              <span className="block text-white" style={{ letterSpacing: '0.02em' }}>
                Transform Your
              </span>
              <span className="block text-white" style={{ letterSpacing: '0.02em' }}>
                Business With
              </span>
              <span className="block bg-gradient-to-r from-purple-400 to-blue-500 bg-clip-text text-transparent pb-1" style={{ letterSpacing: '0.01em' }}>
                Invotage
              </span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-xl leading-relaxed">
              Invotage delivers world-class digital solutions tailored for American businesses. From custom software development to cutting-edge web applications, we turn your ambitious ideas into powerful, scalable technology that drives growth and delivers real results.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => setIsModalOpen(true)}
                className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-8 py-6 text-lg rounded-full shadow-lg shadow-purple-500/50 hover:shadow-purple-500/70 transition-all duration-300 group"
              >
                Start Your Project
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={() => setIsModalOpen(true)}
                variant="outline" 
                className="border-2 border-purple-500 text-white hover:bg-purple-500/10 px-8 py-6 text-lg rounded-full"
              >
                View Services
              </Button>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative animate-fade-in">
            <div className="relative z-10">
              <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/20 to-blue-600/20 rounded-3xl"></div>
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978"
                alt="Professional team collaboration"
                className="rounded-3xl shadow-2xl shadow-purple-900/50 w-full h-auto object-cover ring-1 ring-purple-500/20"
              />
            </div>
            {/* Decorative dots */}
            <div className="absolute -top-8 -right-8 w-32 h-32 opacity-20">
              <div className="grid grid-cols-4 gap-3">
                {[...Array(16)].map((_, i) => (
                  <div key={i} className="w-2 h-2 bg-purple-500 rounded-full"></div>
                ))}
              </div>
            </div>
            <div className="absolute -bottom-8 -left-8 w-24 h-24 opacity-20">
              <div className="grid grid-cols-3 gap-3">
                {[...Array(9)].map((_, i) => (
                  <div key={i} className="w-2 h-2 bg-blue-500 rounded-full"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    {/* Contact Modal */}
    <ContactModal 
      isOpen={isModalOpen} 
      onClose={() => setIsModalOpen(false)}
      title="Start Your Project"
    />
    </>
  );
};

export default Hero;